import moment from 'moment';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import UniDialog from "../../Common/UniDialog";
import UploadResendOrderForm from "../../ResendOrderManagement/UploadResendOrderForm";


function UploadResendOrderModal(props){
    const {open, onClose, branches, onFinish} = props
    const {t} = useTranslation('resendOrders');

    const dataRef = useRef();

    const handleOnFinish = () => {
        onFinish(dataRef.current)
    }

    const handleDataChange = (date, branch, file) => {
        dataRef.current = {
            req_date: moment(date, "YYYY-MM-DD").format("YYYYMMDD"),
            // warehouse: branch,
            file: file
        }
    }

    return (
        <UniDialog
            title={t('resend_order')}
            open={open}
            maxWidth='xs'
            fullWidth
            onClose={onClose}
            onFinish={handleOnFinish}
            autoClose={false}
        >
            <UploadResendOrderForm 
                branches={branches}
                onDataChange={handleDataChange}
            />
        </UniDialog>
    )
}

export default UploadResendOrderModal